import { useRef, useState, useEffect } from 'react';

interface UseTransientButtonOptions {
  initial?: string;
  transient?: string;
  duration?: number;
}

export const useTransientButton = (options?: UseTransientButtonOptions) => {
  const {
    initial = 'Save',
    transient = 'Saved',
    duration = 3000
  } = options ?? {};

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [transientBtn, setTransientBtn] = useState<string>(initial);

  const transientShow = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setTransientBtn(transient);
    timeoutRef.current = setTimeout(() => {
      setTransientBtn(initial);
      timeoutRef.current = null;
    }, duration);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return { transientBtn, transientShow };
};